import { HIDDEN_CURRENCY, isValuesHidden } from './privacy';

/**
 * Formata dinheiro ignorando o modo privacidade.
 *
 * Para as telas em que esconder o número é pior do que mostrá-lo: comprovantes que o cliente
 * baixa e envia a terceiros, a conferência antes de autorizar um lote de pagamentos, as
 * opções de parcelamento e a calculadora de taxas. Esconder ali não protege ninguém — só
 * leva a pessoa a confirmar no escuro ou a mandar um comprovante ilegível.
 */
export const formatCurrency = (value?: number | string) => {
  if (!value) return 'R$ 0,00';

  if (typeof value === 'string') value = Number(value);
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const maskCurrency = (value: number | string) => {
  // O zero é escondido junto: um saldo zerado à mostra já é informação.
  if (isValuesHidden()) return HIDDEN_CURRENCY;

  return formatCurrency(value);
};

export const onlyNumbers = (value: string) => {
  return value?.replace(/\D/g, '');
};
